module.exports = __webpack_public_path__ + "img/article-1.bfc29386.jpg";